namespace advisorop.components.identity {

    class ChangePasswordFormController {
        
        $router;
        user: domains.identity.IUser = {};
        hasPpSSO = false;
        laddaChangePwdInProgress = false;
        passwordChangeSuccess = false; // we will hide change password button if success
        pnlMainPanel: advisorop.components.widgets.AdvisoropPanelController;

        public model: domains.identity.IChangePasswordModel;
        public ppUserData: {
            id?: number,
            username?: string,
            password?: string,
            confirmPassword?: string,
            dateCreated?: Date,
            dateChanged?: Date
        } = {
                // we need this to prevent browser autofill
                username: "",
                password: "",
                confirmPassword: ""
            }
        
        constructor(
            private identityService: services.IdentityService,
            private advisorPpService: services.AdvisorPpService,
            private gs: services.GeneralService) {

            this.model = new domains.identity.ChangePasswordModel();
        }
        
        onMainPanelReady(ctrl) {
            this.pnlMainPanel = ctrl;
        }

        changePassword(): void {
            // this.pnlMainPanel.showLoadingPanel();
            var r = this.$router;
            this.laddaChangePwdInProgress = true;
            this.identityService.changePassword(this.model)
                .then(resp => {
                    this.passwordChangeSuccess = true;
                    if (resp.data.warning) {
                        toastr.warning(resp.data.warning);
                    }
                    toastr.info("You have successfully changed your password.");
                    
                    //setTimeout(() => {
                    //    window.location.href = "/";
                    //    //r.navigate(["Dashboard"]);
                    //}, 2000);
                }, err => this.gs.showError(err))
                .finally(() => {
                    // this.pnlMainPanel.hideLoadingPanel();
                    this.laddaChangePwdInProgress = false;
                });
        };

        setupPpSso(): void {
            this.advisorPpService.setupSso(this.ppUserData)
                .then(response => {
                    this.ppUserData = response.data;
                }, err => this.gs.showError(err));
        }

        checkPpSso(): void {
            // we only support Advisors
            if (this.user.systemLoginType === domains.SystemLoginType.ADVISOR) {
                this.hasPpSSO = true;
                this.advisorPpService.checkSso()
                    .then(response => {
                        if (response.data.id > 0) {
                            this.ppUserData = response.data;
                        }
                    }, err => this.gs.showError(err));
            } else {
                this.hasPpSSO = false;
            }
        }

        async $onInit() {
            this.user = await this.identityService.getUserPromise();

            // until now we only support this for Advisors
            this.checkPpSso();
        }

        $routerOnActivate(next, previous) {
        }
    }
    
    class ChangePasswordForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                $router: "<"
            };
            this.controller = ["identityService", "advisorPpService", "generalService", ChangePasswordFormController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/change-password-form.html';
        }

    }
    angular.module(Constants.APP).component("changePasswordForm", new ChangePasswordForm());
}